import { render, staticRenderFns } from "./CalendarProductSelector.vue?vue&type=template&id=56b689b3&scoped=true&"
import script from "./CalendarProductSelector.vue?vue&type=script&lang=js&"
export * from "./CalendarProductSelector.vue?vue&type=script&lang=js&"
import style0 from "./CalendarProductSelector.vue?vue&type=style&index=0&id=56b689b3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b689b3",
  null
  
)

export default component.exports